import { IData, IItemData } from './index'

export default function fetchBookingIntegrationList(
  api: GlobalFetch,
): () => Promise<Array<IItemData>> {
  return async function() {
    const buildUrl = `/api/v2/booking/list`
    const response = await api.fetch(buildUrl)

    return await handleResponse(response)
  }
}

const handleResponse = async (
  response: Response,
): Promise<Array<IItemData>> => {
  const { status } = response

  if (status === 200) {
    const data: IData = await response.json()
    return data.items
  }

  throw new Error('Error')
}
